import React from 'react';
import { useNavigate } from 'react-router-dom';
import DepartmentForm from '../../components/Departments/DepartmentForm';
import './DepartmentPages.css';

const DepartmentCreate = () => {
  const navigate = useNavigate();

  return (
    <div className="department-page">
      <div className="page-header">
        <button onClick={() => navigate('/app/departments')} className="back-button">
          <i className="fas fa-arrow-left"></i> Back to Departments
        </button>
        <h1>Create New Department</h1>
      </div>
      <DepartmentForm />
    </div>
  );
};

export default DepartmentCreate;


